<template>
    <div>
        <DetailPageSkeletonLarge/>
        <DetailPageSkeletonNarrow/>
    </div>
</template>
<style scoped lang="scss">
@include responseTo(pc-800px) {
    .skeleton-large {
        display: block;
    }
    .skeleton-narrow {
        display: none;
    }
}

@include responseTo(web-999px) {
    .skeleton-large {
        display: none;
    }
    .skeleton-narrow {
        display: block;
    }
}
</style>
